export const UpdateWithVariables = (url: string, data: any) => {
    if (data) {
        let dynamicParams = url.match(/:[A-Z_]*/gi)
        dynamicParams?.map(key => {
            if (key.length > 1) url = url.replace(key, data[key.replace(':', '')])
        })
    }
    return url
}


export const getSelectedValue = (value: any, node: string, options: any[]) => {
    let getValue = (val: any) => {
        let result = null;
        options && options.map((option: any) => {
            if (option[node] == val) {
                result = option;
            }
        })
        return result;
    }
    if (Array.isArray(value)) {
        let selected: any = []

        value.map((val: any) => {
            selected.push(getValue(val))
        })
        return selected;
    } else {
        return getValue(value);
    }
}